import { Injectable } from '@angular/core';
import { IDatiqAction, IDatiqRulesData, IqActionsService } from '@dat/iq-proxy';
import { IqWorkflowTransformationService } from './iq-workflow-transformation.service';
import { IqWorkflowStateActionService } from './iq-workflow-state-action.service';

@Injectable({
    providedIn: 'root',
})
export class IqWorkflowActionProcessorService {
    constructor(
        private readonly _actions: IqActionsService,
        private readonly _transformation: IqWorkflowTransformationService,
        private readonly _actionState: IqWorkflowStateActionService,
    ) {}

    processActions(
        actions: IDatiqRulesData<IDatiqAction>[],
        componentData: unknown,
    ): IDatiqAction[] {
        const renderedActions: IDatiqRulesData<IDatiqAction>[] =
            this._transformation.render(JSON.stringify(actions), componentData);

        this._actions.fireValidActions(renderedActions);
        this._actionState.fireValidActions(renderedActions);

        return renderedActions?.map?.((action) => action.data) ?? [];
    }
}
